const UUID_PATTERN =
  "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

const BACKEND_URL = (
  (import.meta.env.VITE_APP_BACKEND_URL as string) || ""
).replace(/\/+$/, "");

const escapeRegex = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const IMAGE_MARKER_PREFIX = "commons-image:";

const MARKER_RE = new RegExp(
  `${escapeRegex(IMAGE_MARKER_PREFIX)}(${UUID_PATTERN})`,
  "g",
);

const URL_RE = new RegExp(
  `${escapeRegex(BACKEND_URL)}/media/(${UUID_PATTERN})/?`,
  "g",
);

const BLOB_IMG_RE = /<img\s+[^>]*\bsrc=["'](blob:[^"']+)["'][^>]*>/gi;

export const mediaDisplayUrl = (id: string): string =>
  `${BACKEND_URL}/media/${id}/`;

export const buildImageMarker = (id: string): string =>
  `${IMAGE_MARKER_PREFIX}${id}`;

export const rewriteMarkersForDisplay = (html: string): string => {
  if (!html) return html;
  return html.replace(MARKER_RE, (_match, id: string) => mediaDisplayUrl(id));
};

export const rewriteUrlsToMarkers = (html: string): string => {
  if (!html) return html;
  return html.replace(URL_RE, (_match, id: string) => buildImageMarker(id));
};

export const rewriteBlobsToMarkers = (
  html: string,
  blobToId: Map<string, string>,
): string => {
  if (!html) return html;
  return html.replace(BLOB_IMG_RE, (match, blobUrl: string) => {
    const id = blobToId.get(blobUrl);
    if (!id) return "";
    return match.replace(blobUrl, buildImageMarker(id));
  });
};
